var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatcherIconXy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.047,
    height: 385.786,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "catcherIconXy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 286",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h200v200H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "catcherIconXy_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 287",
    fill: "none",
    d: "M0 0h200v200H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#catcherIconXy_svg__a)",
    transform: "translate(20.995 92.838)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000",
    clipPath: "url(#catcherIconXy_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M100.074 21.52c-27.62 0-50.008 21.9-50.008 48.924 0 17.63 7.884 35.526 22.78 42.97h54.45c14.9-7.444 22.78-25.34 22.78-42.97.006-27.02-22.382-48.924-50-48.924m0 79.484a31.523 31.523 0 1131.522-31.523 31.523 31.523 0 01-31.524 31.523m0-59.492A27.969 27.969 0 10128.04 69.48a27.97 27.97 0 00-27.966-27.968"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M153.362 162.525l29.626-45.242-40.536-27.435 7.148-12 47.781 33.058a6.085 6.085 0 011.542 8.466c-.02.032-.042.06-.064.092l-40.26 49.886-28.86 9.06a1.52 1.52 0 01-1.166-2.794z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M46.641 162.525l-29.626-45.239 40.536-27.438-7.148-12-47.778 33.058a6.085 6.085 0 00-1.542 8.466c.02.032.042.06.064.092l40.26 49.886 28.86 9.06a1.52 1.52 0 001.166-2.794z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "2Arrows"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M54.431 76.907v11.555h126.185V76.907l52.928 18.671-52.928 18.668v-11.32H54.431v11.32L1.503 95.575z",
    fill: "#ff3e3e",
    stroke: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M86.16 38.267l-8.03 8.308 90.726 87.698 8.031-8.308 25.079 50.21-51.03-23.363 7.868-8.14-90.727-87.698-7.867 8.14-25.08-50.21z",
    fill: "#3086ff",
    stroke: "#4d4d4d",
    strokeWidth: 0.99999
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "arrow.image"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 2",
    d: "M141.193 248.434h-11.555v95.928h11.555l-18.671 40.236-18.668-40.236h11.32v-95.928h-11.32l18.671-40.236z",
    fill: "#00b050",
    stroke: "#4d4d4d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatcherIconXy);
export default __webpack_public_path__ + "static/media/catcherIconXy.2e0958febcfa0b76.svg";
export { ForwardRef as ReactComponent };